import './index.css';
import i18next from 'i18next';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import translation_en from './translations/en/translation.json';
import translation_pl from './translations/pl/translation.json';
import translation_nl from './translations/nl/translation.json';
import translation_chi from './translations/chi/translation.json';
import translation_de from './translations/de/translation.json';
import translation_fr from './translations/fr/translation.json';
import { initReactI18next } from 'react-i18next';
import store from './store/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ensureLanguageCode } from './shared/services/language.service';

i18next.use(initReactI18next).init({
    interpolation: { escapeValue: false },
    lng: ensureLanguageCode(),
    fallbackLng: false,
    returnNull: false,
    returnEmptyString: false,
    resources: {
        en: { translation: translation_en },
        pl: { translation: translation_pl },
        de: { translation: translation_de },
        nl: { translation: translation_nl },
        chi: { translation: translation_chi },
        fr: { translation: translation_fr },
    },
    react: {
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    },
});

export default i18next;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <BrowserRouter>
        <Provider store={store}>
            <I18nextProvider i18n={i18next}>
                <App />
            </I18nextProvider>
        </Provider>
    </BrowserRouter>
);
